<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SummaryReports from '../SummaryReports.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: value => ['agent', 'inbox', 'team', 'label'].includes(value),
  },
  since: { type: Date, required: true },
  until: { type: Date, required: true },
  businessHours: { type: Boolean, default: false },
});

// Reaproveitado pelas 4 seções com tela de resumo + detalhe (Usuários,
// Etiquetas, Canais, Time) — cada uma só muda o `type`. Ver spec 143 Parte B.
const TYPE_CONFIG = {
  agent: {
    getterKey: 'agents/getAgents',
    actionKey: 'summaryReports/fetchAgentSummaryReports',
    summaryKey: 'summaryReports/getAgentSummaryReports',
    fetchItemsKey: 'agents/get',
    downloadLabelKey: 'AGENT_REPORTS.DOWNLOAD_AGENT_REPORTS',
    detailRouteName: 'painel_agent_reports_show',
  },
  inbox: {
    getterKey: 'inboxes/getInboxes',
    actionKey: 'summaryReports/fetchInboxSummaryReports',
    summaryKey: 'summaryReports/getInboxSummaryReports',
    fetchItemsKey: 'inboxes/get',
    downloadLabelKey: 'INBOX_REPORTS.DOWNLOAD_INBOX_REPORTS',
    detailRouteName: 'painel_inbox_reports_show',
  },
  team: {
    getterKey: 'teams/getTeams',
    actionKey: 'summaryReports/fetchTeamSummaryReports',
    summaryKey: 'summaryReports/getTeamSummaryReports',
    fetchItemsKey: 'teams/get',
    downloadLabelKey: 'TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS',
    detailRouteName: 'painel_team_reports_show',
  },
  label: {
    getterKey: 'labels/getLabels',
    actionKey: 'summaryReports/fetchLabelSummaryReports',
    summaryKey: 'summaryReports/getLabelSummaryReports',
    fetchItemsKey: 'labels/get',
    downloadLabelKey: 'LABEL_REPORTS.DOWNLOAD_LABEL_REPORTS',
    detailRouteName: 'painel_label_reports_show',
  },
};

const { t } = useI18n();
const config = TYPE_CONFIG[props.type];
const summaryReportsRef = ref(null);
// Usuários/Canais/Time ganham a barra ranqueada por conversas resolvidas;
// Etiquetas fica só com a tabela (dono pediu os 3 primeiros, não os 4).
const showRankingChart = props.type !== 'label';

const onDownloadClick = () => summaryReportsRef.value.downloadReports();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div class="flex justify-end">
      <Button
        :label="t(config.downloadLabelKey)"
        icon="i-ph-download-simple"
        size="sm"
        @click="onDownloadClick"
      />
    </div>
    <SummaryReports
      ref="summaryReportsRef"
      :type="type"
      :getter-key="config.getterKey"
      :action-key="config.actionKey"
      :summary-key="config.summaryKey"
      :fetch-items-key="config.fetchItemsKey"
      :detail-route-name="config.detailRouteName"
      :since="since"
      :until="until"
      :business-hours="businessHours"
      :show-ranking-chart="showRankingChart"
    />
  </div>
</template>
